<template>
    <v-row class="ma-0">
        <v-col :cols="maxColumns" style="min-width: 300px;" v-for="(item, index) in progress" :key="index">
            <DashboardProgressInCompleting :item="item" v-if="$auth.policies['statistic-list:list-psi']" />
        </v-col>
    </v-row>
</template>
<script>
import DashboardProgressInCompleting from '@/modules/dashboard/DashboardProgressInCompleting.vue'
import { mapGetters, mapActions, mapState } from 'vuex'
import { getFirestore, onSnapshot, collection } from 'firebase/firestore'
export default {
  components: {
    DashboardProgressInCompleting,
  },
  watch: {
    firebaseApp: {
      handler(val) {
        if (val && this.$auth.policies['statistic-list:list-psi']) this.setupFireStore()
      }
    }
  },
  mounted() {
    if (this.firebaseApp && this.$auth.policies['statistic-list:list-psi']) {
      this.setupFireStore()
    }
    this.onResize()
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    ...mapActions({
      fetchImportOrdersItem: 'importOrders/fetchItems',
    }),
    setupFireStore(app) {
      const db = getFirestore(app)
      onSnapshot(collection(db, 'report-psi'), querySnapshot => {
        this.progress = []
        querySnapshot.forEach(doc => {
          const data = doc.data()
          this.progress.push(data)
        })
        console.log(this.progress)
        this.progress.sort((a, b) => {
          return a.index - b.index
        })
      })
    },
    onResize() {
      this.windowWidth = window.innerWidth
      if (this.windowWidth < 1630) {
        this.maxColumns = 4
      }
      if (this.windowWidth < 1260) {
        this.maxColumns = 6
      }
      if (this.windowWidth < 1030) {
        this.maxColumns = 12
      }
      if (this.windowWidth > 1630) {
        this.maxColumns = 3
      }
    }
  },
  computed: {
    ...mapState({
      workList(state) {
        return state['importOrders'].workList
      },
    }),
    ...mapGetters({
      firebaseApp: 'firebase/firebaseApp'
    })
  },
  data() {
    return {
      progress: [],
      windowWidth: window.innerWidth,
      maxColumns: 3,
    }
  }
}
</script>
<style>
.sty_detail {
    font-size: 14px;
}
</style>
